import ARSAccordian from './ARSAccordian';

export default ARSAccordian;
